
import Navbar from '../H&F/Navbar';
import Footer from '../H&F/Footer';
import React, { useEffect } from 'react';
import './privacy-policy.css'
import Discliamber from './Discliamer'
export default function PRIVACYPOLICY() {



  useEffect(() => {
              window.scrollTo(0, 0); // Scroll to the top of the page
            }, []);
  return (
    <>
    
    
     <div><Navbar /></div>
    
    <section id="privacy-policy">
    <div class="container">
      <h2>Privacy Policy</h2>
      <p>At <strong>Home Appliance Service Madurai</strong>, we value your privacy and are committed to protecting your personal information. Below is an explanation of how we collect and use your personal data:</p>
      
      <h3>Why We Collect Your Personal Information</h3>
      <p>We collect your <strong>Name, Phone Number, and Address</strong> to provide personalized and efficient service. This information is used to:</p>
      <ul>
        <li><strong>Schedule Future Services:</strong> We use your contact details to schedule and arrange the next service appointment.</li>
        <li><strong>Follow Up on Services:</strong> We may contact you for feedback or additional follow-ups to ensure the quality of our service.</li>
      </ul>
  
      <h3>Your Data Security</h3>
      <p>Your privacy is important to us. We do not share your personal information with any third parties. All collected data is stored securely in <strong>Google Sheets</strong> for record-keeping and efficient customer support.</p>
      
      <h3>How We Protect Your Information</h3>
      <p>We ensure that all customer information is kept confidential and secure. Your details are only used for service-related purposes and will never be sold or shared with any unauthorized parties.</p>
      
      <h3>Contact Us</h3>
      <p>If you have any concerns or questions about your privacy, please contact us at <strong><a href="mailto:hasmadurai@gmail.com">hasmadurai@gmail.com</a></strong> or call <strong>+918610867933</strong>.</p>
    </div>
  </section>
  <div><Discliamber/></div>
  <div><Footer/></div>
  </>
  
  )
}
